export const RefetchIntervals = {
    /** 10 seconds — real-time views */
    short: 10 * 1000,
    /** 30 seconds — live dashboards, conference views, device reports */
    medium: 30 * 1000,
    /** 1 minute — notifications, counters */
    long: 60 * 1000,
    extraLong: 5 * 60 * 1000,
} as const
